import React from 'react';
import { Spin } from 'antd';

export class LoadingSpinner extends React.Component {
  render() {
    return (
      <div className="text-center my-5">
        <Spin size="large" delay={500} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/presentation/LoadingSpinner.jsx